// JavaScript Document

// navbar clickover hide
$(document).click(function (event) {
    var clickover = $(event.target);
    var $navbar = $(".navbar-collapse");               
    var _opened = $navbar.hasClass("in");
    if (_opened === true && !clickover.hasClass("navbar-toggle")) {      
        $navbar.collapse('hide');
    }
});

//sticky header start

$(document).ready(function() {
   $('.header').removeClass("sticky");
  });
$(window).scroll(function() {
if ($(this).scrollTop() > 1){  
$('.header').addClass("sticky");
}
else{
$('.header').removeClass("sticky");
}
});

//sticky header end 

// owl carousel start js
$(document).ready(function() {
    $('.owl-carousel').owlCarousel({
        margin: 20,
      autoPlay: 3000,
		loop: true,
        responsive: {
			 0: {
            items: 2
          },
          420: {
            items: 4
          },
          600: {
            items: 5
          },
          1000: {
            items: 7
          }
		  ,
          1200: {
            items: 7
          }
        }
      });
});
// owl carousel startend


